<template>
  <div class="auth-input-wrapper">
    <input :class="{ error: !password.isValid,
          valid: (password.isValid && password.length > 0) }"
      @input="validateWithDebounce"
      @blur="validate"
      v-model="value"
      type="password"
      id="password"
      required
    >
    <label for="password">Hasło</label>
    <p class="error" v-if="password.isTooShort">Treść pola jest zbyt krótka!</p>
    <p class="error" v-else-if="password.isTooLong">Treść pola jest zbyt długa!</p>
    <p class="error"
      v-if="!password.isAlphanumeric
      && !password.isTooShort
      && !password.isTooLong">
      Hasło musi zawierać przynajmniej jedną małą literę,
      jedną wielką literę oraz jedną cyfrę!</p>
  </div>
</template>

<script>
import {
  validatePassword, validateMatch, debounce, debounceOffset
} from '../authValidation';

export default {
  name: 'PasswordAuthInput',
  data() {
    return {
      password: {
        isValid: true,
        isTooShort: false,
        isTooLong: false,
        isAlphanumeric: true,
        length: 0
      }
    };
  },
  computed: {
    value: {
      get() {
        return this.$store.getters.registrationPassword;
      },
      set(value) {
        this.$store.commit('updateRegistrationPassword', value);
      }
    },
    repeatPassword: {
      get() {
        return this.$store.getters.registrationRepeatPassword;
      }
    }
  },
  methods: {
    validateWithDebounce(e) {
      debounce(() => {
        this.$store.dispatch('clearAllAuthErrors');
        this.validate(e);
      }, debounceOffset);
    },
    validate(e) {
      validatePassword(e, this.password);
      this.$store.commit('updateIsRegistrationPasswordValid', this.password.isValid);
      this.$store.commit('updateIsRegistrationPasswordMatch',
        validateMatch(this.value, this.repeatPassword));
    }
  }
};
</script>
